import CompanyService from "../../../services/CompanyService";
import { TranslationService } from "../../../services/TranslationService";
import { CultureData } from "./CultureData";
import { EmailsNotificationsData } from "./EmailsNotificationsData";
import { BrowserNotificationsData } from "./BrowserNotificationsData";
import { SignData } from "./SignData";

export const CompanyConfiguration = () => {
  const allowBrowserNotifications =
    CompanyService.canUseWhatsappNotifications();
  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <h4 className="mb-2">{TranslationService.translate.Preferences}</h4>
        {CompanyService.getCompanies().filter(
          (x) => x.Id !== CompanyService.getCompanyId()
        ).length > 1 ? (
          <p className="alert-text">
            {TranslationService.translate.PreferencesNote}.
          </p>
        ) : null}
        <div className="card">
          <SignData />
          <CultureData />
          <EmailsNotificationsData />
          {allowBrowserNotifications && <BrowserNotificationsData />}
        </div>
      </div>
    </div>
  );
};
